var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('name')}},[_c('b-input-group',{staticClass:"mb-1"},[_c('div',{staticClass:"label-as-input"},[_vm._v(_vm._s(_vm.isNotNullValue(_vm.formData.name)))])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }